import { SERVER_ROUTES } from "../../enums/Enums";
import * as axiosActions from "../../managers/Axios/AxiosActions";
import { trackException } from "../Azure/ApplicationInsightsActions";

export const getBillingRules = (siteIds, isShowSpinner = true, closeSpinner = true) => {
    return new Promise((resolve, reject) => {
      var body = siteIds;

      axiosActions
        .POST(SERVER_ROUTES.BILLING_RULES_BY_SITE_ID, body, isShowSpinner, closeSpinner)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          trackException("ActionsService.js - getBillingRules()", error);
          reject(error);
        });
    });
  };

  export const addBillingRule = (createBillingRule) => {
    return new Promise((resolve, reject) => {
    var body = createBillingRule;

      axiosActions
        .POST(SERVER_ROUTES.BILLING_RULES, body)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          trackException("ActionsService.js - addBillingRule()", error);
          reject(error);
        });
    });
  };

  export const updateBillingRule = (updateBillingRule) => {
    return new Promise((resolve, reject) => {
    var body = updateBillingRule;

      axiosActions
        .PUT(SERVER_ROUTES.BILLING_RULES, body)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          trackException("ActionsService.js - updateBillingRule()", error);
          reject(error);
        });
    });
  };

  export const deleteBillingRule = (ruleId, isShowSpinner = true, closeSpinner = true) => {
    return new Promise((resolve, reject) => {
      var queryParams = ruleId;
  
      axiosActions
        .DELETE(SERVER_ROUTES.BILLING_RULES + queryParams, null, isShowSpinner, closeSpinner)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          trackException("ActionsService.js - deleteBillingRule()", error);
          reject(error);
        });
    });
  };
